import React from 'react';
import './Skeleton.css';

export function MetricSkeleton() {
  return (
    <div className="metric-skeleton">
      <div className="skeleton-header">
        <div className="skeleton-icon shimmer" />
        <div className="skeleton-title-group">
          <div className="skeleton-title shimmer" />
          <div className="skeleton-subtitle shimmer" />
        </div>
      </div>
      <div className="skeleton-body">
        <div className="skeleton-row">
          <div className="skeleton-label shimmer" />
          <div className="skeleton-value shimmer" />
        </div>
        <div className="skeleton-row">
          <div className="skeleton-label shimmer" />
          <div className="skeleton-value shimmer" />
        </div>
        <div className="skeleton-row">
          <div className="skeleton-label shimmer" />
          <div className="skeleton-value shimmer" />
        </div>
      </div>
    </div>
  );
}

export function DashboardSkeleton() {
  return (
    <div className="dashboard-skeleton">
      <MetricSkeleton />
      <MetricSkeleton />
      <MetricSkeleton />
      <MetricSkeleton />
    </div>
  );
}
